import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { WhiteColumnLayout, LayoutColumn, WhiteLayout } from "netcompany-mdx-slide";
import nlntImage from "./assets/nlnt.jpg";
import pctImage from "./assets/pct.jpg";
import netcompanyMap from "./assets/netcompany-map-2.png";
import netcompanyIndex from "./assets/netcompany-index.png";
import netcompanyService from "./assets/netcompany-service.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <WhiteLayout title={"Agenda"} mdxType="WhiteLayout">
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Introduction.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`OOP 101.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`The case study.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Example from real projects.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Summary.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Practical.`}</p>
        </li>
      </ul>
    </WhiteLayout>
    <hr></hr>
    <WhiteColumnLayout title={"Introduction"} sizes={[4, 3]} colors={['#fff', '#0f2147']} texts={['#0f2147', '#fff']} mdxType="WhiteColumnLayout">
      <LayoutColumn mdxType="LayoutColumn">
        <h3>{`Nguyen Le Nhat Truong`}</h3>
        <ul>
          <li parentName="ul">{`B.Sc in Software Engineering by FPT Uni.`}</li>
          <li parentName="ul">{`9 years of working experience in IT industry.`}</li>
          <li parentName="ul">{`I started in Netcompany in November 2020 as a consultant:`}
            <ul parentName="li">
              <li parentName="ul">{`Developer in a Web application project.`}</li>
              <li parentName="ul">{`Team lead and software architect.`}</li>
            </ul>
          </li>
          <li parentName="ul">{`Today I'm the Senior Architect for Netcompany Vietnam.`}</li>
        </ul>
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <img src={nlntImage} alt="nlnt" />
      </LayoutColumn>
    </WhiteColumnLayout>
    <hr></hr>
    <WhiteColumnLayout title={"Netcompany at a glance"} colors={['#fff', '#0f2147']} texts={['#0f2147', '#fff']} mdxType="WhiteColumnLayout">
      <LayoutColumn fontSize={"0.7em"} fontFamily={"Varela Round"} mdxType="LayoutColumn">
        <p>{`Netcompany is one of Europe’s fastest growing and most successful IT services companies, leading the way in showing how digital transformation can create strong, sustainable societies, successful companies and better lives for us all.`}</p>
        <p>{`Our ambition is to become the market leader within IT services in Europe. The acquisition of Intrasoft in 2021 has strengthened our foundation to achieve that ambition - further expanding our portfolio of platforms and unique expertise across sectors with a global headcount of +7,400 talented employees.`}</p>
        <p>{`By building flexible, scalable and secure digital platforms, Netcompany is positioned to help Europe thrive through a decade of massive digitisation.`}</p>
        <img src={netcompanyIndex} style={{
          maxWidth: "100%"
        }} alt="netcompany-index" />
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <img src={netcompanyMap} style={{
          width: "100%"
        }} alt="netcompany" />
      </LayoutColumn>
    </WhiteColumnLayout>
    <hr></hr>
    <WhiteLayout title={"An active end-to-end service provider"} mdxType="WhiteLayout">
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1
      }}>
  <img src={netcompanyService} style={{
          width: "100%"
        }} alt="netcompany" />
      </div>
    </WhiteLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      